import { FeathersModel } from './feathersModel'

export class AnnouncementRead extends FeathersModel {
  static serviceName = 'announcement-read'

  announcementId: number
  userId: number
}
